export default {"src":"/_next/static/media/modx.0599d3b3.svg","height":124,"width":121,"blurWidth":0,"blurHeight":0};